import React from 'react';
import jsPDF from 'jspdf';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import PText from '../components/PText';
import Resume from '../assets/images/resume.png';
import AboutImg from '../assets/images/about-page-img.jpg';
import AboutInfoItem from '../components/AboutInfoItem';
import ContactBanner from '../components/ContactBanner';

const AboutPageStyles = styled.div`
  padding: 20rem 0 10rem 0;

  .button {
    margin: 2rem;
    font-size: 2.2rem;
    background-color: ${(props) =>
      props.outline ? 'transperant' : 'var(--gray-1)'};
    padding: 0.7em 2em;
    border: 2px solid var(--gray-1);
    border-radius: 8px;
    display: inline-block;
    color: ${(props) => (props.outline ? 'var(--gary-1)' : 'black')};
  }
  @media only screen and (max-width: 768px) {
    .center {
      display: flex;
      justify-content: center;
      flex-direction: column;
    }
    .button {
      font-size: 1.8rem;
      margin: 1rem 0rem;
      text-align: center;
    }
  }
  .top-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
  }
  .left {
    flex: 3;
  }
  .right {
    flex: 2;
  }
  .about__subheading {
    font-size: 2.2rem;
    margin-bottom: 2rem;
    span {
      background-color: var(--deep-dark);
      padding: 0.5rem;
      border-radius: 8px;
    }
  }
  .about__heading {
    font-size: 3.6rem;
    margin-bottom: 3rem;
  }
  .about__info {
    margin-bottom: 4rem;
    .para {
      max-width: 100%;
    }
  }
  .right {
    img {
      border: 2px solid var(--gray-1);
    }
  }
  .about__info__items {
    margin-top: 15rem;
  }
  .about__info__item {
    margin-bottom: 10rem;
  }
  .about__info__heading {
    font-size: 3.6rem;
    text-transform: uppercase;
  }
  @media only screen and (max-width: 768px) {
    padding: 10rem 0;
    .top-section {
      flex-direction: column;
      gap: 5rem;
    }
    .about__subheading {
      font-size: 1.8rem;
    }
    .about__heading {
      font-size: 2.8rem;
    }
    .about__info__heading {
      font-size: 3rem;
    }
  }
`;

export default function About() {
  const generatePDF = () => {
    const doc = jsPDF('landscape', 'px', 'a4', 'false');
    doc.addImage(Resume, 'PNG', 125, -20, 400, 480);
    doc.save('Resume.pdf');
  };
  return (
    <>
      <AboutPageStyles>
        <div className="container">
          <div className="top-section">
            <div className="left">
              <p className="about__subheading">
                Hi, I am <span>Arun Choudhary</span>
              </p>
              <h2 className="about__heading">A freelance Web developer</h2>
              <div className="about__info">
                <PText>
                  I am from Indore, Madhya Pradesh. A place of beauty and
                  nature. Since my childhood, i love art and design. I always
                  try to design stuff with my unique point of view. I also love
                  to create things that can be usefull to others.
                  <br /> <br />
                  I started coding since I was in high school. Coding is also an
                  art for me. I love it and now I have the opportunity to design
                  along with the coding. I find it really interesting and I
                  enjoyed the process a lot.
                  <br />
                  <br />
                  My vision is to make the world a better place. Now almost
                  everything is becoming better than ever. It is time for us to
                  create more good stuff that helps the world to become a better
                  place.
                </PText>
              </div>
              <div className="center">
                <Link className="button" to="#" onClick={generatePDF}>
                  Download CV
                </Link>
                <a
                  href="https://mail.google.com/mail/u/0/#inbox?compose=CllgCJqbQnSxbpmXkpGnvZGLfnrLjFWRdNDZVWCvPRpqmpzrfvjllmqkggZFfqkQMRbFXrVVLLB"
                  target="_blank"
                  rel="noreferrer"
                  className="button"
                >
                  Hire me
                </a>
              </div>
            </div>
            <div className="right">
              <img src={AboutImg} alt="me" />
            </div>
          </div>
          <div className="about__info__items">
            <div className="about__info__item">
              <h1 className="about__info__heading">Education</h1>

              <AboutInfoItem
                title="University"
                items={['Medi-Caps Indore', ':- BS.c(CS) & MCA']}
              />
              <AboutInfoItem
                title="Collage"
                items={['ITI Technical Indore', ':- Stenographer (English)']}
              />
              <AboutInfoItem
                title="Institute"
                items={[
                  'Blue Chip Computer Edu..',
                  ':- Manual & CA (TALLY.ERP9)',
                ]}
              />
              <AboutInfoItem
                title="Institute"
                items={[
                  'Shri GuruKrapa Infotech',
                  ':- Office Automation & Internet (COA)',
                ]}
              />
              <AboutInfoItem
                title="School"
                items={[
                  'Vivekanand V. V. High School, Indore',
                  ':- 1st to 12th',
                ]}
              />
            </div>
            <div className="about__info__item">
              <h1 className="about__info__heading">My Skills</h1>

              <AboutInfoItem
                title="FrontEnd"
                items={['HTML', 'CSS', 'JavaScript', 'REACT']}
              />
              <AboutInfoItem title="BackEnd" items={['Node', 'Express']} />
              <AboutInfoItem title="Database" items={['MongoDB', 'Firebase']} />
              <AboutInfoItem
                title="Hosting"
                items={['Github', 'Heroku', 'netlify', 'Firebase']}
              />
              <AboutInfoItem
                title="Design"
                items={['Photoshop', 'After Effects', 'Figma']}
              />
              <AboutInfoItem
                title="Managment"
                items={['Account Manager-TALLY.ERP9']}
              />
            </div>
            <div className="about__info__item">
              <h1 className="about__info__heading">Experiences</h1>

              <AboutInfoItem
                title="2020-2021"
                items={['Front end developer at The Youth Project']}
              />
              <AboutInfoItem title="2020" items={['Freelance web Developer']} />
            </div>
          </div>
        </div>
        <ContactBanner />
      </AboutPageStyles>
    </>
  );
}
